<template>
  <listing-layout>
    <div slot="heading">
      <page-heading>Import</page-heading>
    </div>
    <div slot="content">

      <div v-if="loading" class="text-center py-4">
        <span class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading…</span>
        </span>
      </div>

      <template v-else>
        <import-card
          v-for="item in imports"
          :key="item.type"
          :type="item.type"
          :label="item.label"
        />
        <p v-if="!imports.length" class="text-muted">No imports available.</p>
      </template>

    </div>
  </listing-layout>
</template>

<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api'
import ListingLayout from '@/components/ListingLayout'
import PageHeading from '@/components/PageHeading'
import ImportCard from '@/components/SuperAdmin/ImportCard'
import importApi from '@/services/api/import'

export default defineComponent({
  name: 'Import',
  components: {
    'listing-layout': ListingLayout,
    'page-heading': PageHeading,
    'import-card': ImportCard
  },
  setup() {
    const imports = ref([])
    const loading = ref(false)

    async function fetchList() {
      loading.value = true
      try {
        const res = await importApi.list()
        imports.value = res.data.data
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchList)

    return { imports, loading }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/SuperAdmin/Import/Import.vue